import { createContext, useContext } from 'react';

/**
 * @typedef {object} MapViewportFilter
 * @property {boolean} disabled
 */

/**
 * @typedef {object} MapViewportFilterContext
 * @property {MapViewportFilter} mapViewportFilter
 * @property {React.Dispatch<React.SetStateAction<MapViewportFilter>>} setMapViewportFilter
 */

/** @type {React.Context<MapViewportFilterContext>} */
// @ts-ignore
export const MapViewportFilterContext = createContext(null);

export const useMapViewportFilterContext = () => useContext(MapViewportFilterContext);
